export const DEFAULT_DASHBOARD_PARAMS = {
  theme: 'studio_prod',
};
